import script from "./esTabModel.vue?vue&type=script&setup=true&lang=ts"
export * from "./esTabModel.vue?vue&type=script&setup=true&lang=ts"

import "./esTabModel.vue?vue&type=style&index=0&id=f56ab3c0&lang=css"

const __exports__ = script;

export default __exports__